/**
 * Cart Fiscal Form — cart-fiscal-form.js  (v2 — AJAX attributes)
 *
 * Il form si trova FUORI dal <form action="/cart"> del tema.
 * Gli attributi vengono salvati tramite POST /cart/update.js
 * prima del redirect a /checkout.
 */

(function () {
  'use strict';

  /* ── Selettori pulsante checkout ─────────────────────────────
     Aggiungi qui il selettore esatto del tuo tema se necessario. */
  const CHECKOUT_BTN_SELECTORS = [
    '[name="checkout"]',
    '#checkout',
    '.cart__checkout-button',
    'button[type="submit"].checkout-button',
    '.cart-checkout-button',
  ].join(', ');

  const DISABLED_CLASS = 'fiscal-btn-disabled';

  /* ── Helpers ─────────────────────────────────────────────────── */
  function show(el) {
    if (!el) return;
    el.classList.remove('fiscal-hidden');
    el.classList.add('fiscal-visible');
  }

  function hide(el) {
    if (!el) return;
    el.classList.remove('fiscal-visible');
    el.classList.add('fiscal-hidden');
  }

  function setCheckout(enabled) {
    document.querySelectorAll(CHECKOUT_BTN_SELECTORS).forEach(function (btn) {
      if (enabled) {
        btn.classList.remove(DISABLED_CLASS);
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('tabindex');
      } else {
        btn.classList.add(DISABLED_CLASS);
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('tabindex', '0');
      }
    });
  }

  function showValidationMsg() {
    var msg = document.getElementById('fiscal-validation-msg');
    if (!msg) return;
    show(msg);
    setTimeout(function () { hide(msg); }, 4000);
  }

  /* ── Raccolta attributi dal form ─────────────────────────────── */
  function collectAttributes() {
    var attrs = {};

    var tipoAcquisto = document.getElementById('fiscal-tipo-acquisto');
    if (tipoAcquisto && tipoAcquisto.value)
      attrs['Tipo Acquisto'] = tipoAcquisto.value;

    var soggetto = document.querySelector('.fiscal-radio:checked');
    if (soggetto && soggetto.value)
      attrs['Tipo Soggetto'] = soggetto.value;

    var cf = document.getElementById('fiscal-cf');
    if (cf && cf.value.trim()) attrs['Codice Fiscale'] = cf.value.trim();

    var piva = document.getElementById('fiscal-piva');
    if (piva && piva.value.trim()) attrs['Partita IVA'] = piva.value.trim();

    var sdi = document.getElementById('fiscal-sdi');
    if (sdi && sdi.value.trim()) attrs['Codice SDI'] = sdi.value.trim();

    return attrs;
  }

  /* ── Salva attributi via API Shopify ─────────────────────────── */
  function saveAttributes(callback) {
    var attrs = collectAttributes();

    // Mostra stato di caricamento sul pulsante
    document.querySelectorAll(CHECKOUT_BTN_SELECTORS).forEach(function (btn) {
      btn._originalText = btn.innerHTML;
      btn.innerHTML = '<span style="opacity:0.6">Salvataggio...</span>';
    });

    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ attributes: attrs })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart/update failed: ' + res.status);
      return res.json();
    })
    .then(function () {
      document.querySelectorAll(CHECKOUT_BTN_SELECTORS).forEach(function (btn) {
        if (btn._originalText) btn.innerHTML = btn._originalText;
      });
      callback(null);
    })
    .catch(function (err) {
      console.error('[fiscal-form]', err);
      document.querySelectorAll(CHECKOUT_BTN_SELECTORS).forEach(function (btn) {
        if (btn._originalText) btn.innerHTML = btn._originalText;
      });
      // Procedi comunque per non bloccare l'acquisto
      callback(err);
    });
  }

  /* ── Intercetta click sul pulsante checkout ──────────────────── */
  function onCheckoutClick(e) {
    var btn = e.target.closest(CHECKOUT_BTN_SELECTORS);
    if (!btn) return;

    // Se disabilitato: blocca e mostra messaggio
    if (btn.classList.contains(DISABLED_CLASS)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showValidationMsg();
      return;
    }

    // Se abilitato: salva attributi via API poi redirect a /checkout
    e.preventDefault();
    e.stopImmediatePropagation();

    saveAttributes(function () {
      window.location.href = '/checkout';
    });
  }

  /* ── Validazione ─────────────────────────────────────────────── */
  function validate() {
    var tipoAcquisto = document.getElementById('fiscal-tipo-acquisto');
    if (!tipoAcquisto) return;

    var val = tipoAcquisto.value;

    if (val === 'Acquisto extra Italia') {
      setCheckout(true);
      return;
    }

    if (val === 'Acquisto Italia') {
      var privato = document.getElementById('fiscal-privato');
      var azienda = document.getElementById('fiscal-azienda');

      if (privato && privato.checked) {
        var cf = (document.getElementById('fiscal-cf') || {}).value || '';
        setCheckout(cf.trim().length === 16);
        return;
      }

      if (azienda && azienda.checked) {
        var piva = (document.getElementById('fiscal-piva') || {}).value || '';
        var sdi  = (document.getElementById('fiscal-sdi')  || {}).value || '';
        setCheckout(piva.trim().length === 11 && sdi.trim().length === 7);
        return;
      }
    }

    setCheckout(false);
  }

  /* ── Toggle visibilità campi ─────────────────────────────────── */
  function onTipoAcquistoChange() {
    var val = this.value;

    hide(document.getElementById('fiscal-group-tipo-soggetto'));
    hide(document.getElementById('fiscal-group-cf'));
    hide(document.getElementById('fiscal-group-azienda'));

    document.querySelectorAll('.fiscal-radio').forEach(function (r) { r.checked = false; });
    clearInput('fiscal-cf');
    clearInput('fiscal-piva');
    clearInput('fiscal-sdi');

    if (val === 'Acquisto Italia') {
      show(document.getElementById('fiscal-group-tipo-soggetto'));
    }

    validate();
  }

  function onTipoSoggettoChange() {
    clearInput('fiscal-cf');
    clearInput('fiscal-piva');
    clearInput('fiscal-sdi');

    if (this.value === 'Privato') {
      show(document.getElementById('fiscal-group-cf'));
      hide(document.getElementById('fiscal-group-azienda'));
    } else if (this.value === 'Azienda') {
      hide(document.getElementById('fiscal-group-cf'));
      show(document.getElementById('fiscal-group-azienda'));
    }

    validate();
  }

  function clearInput(id) {
    var el = document.getElementById(id);
    if (el) el.value = '';
  }

  /* ── Sanitizzazione input ────────────────────────────────────── */
  function onCFInput()   { this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g, ''); validate(); }
  function onPIVAInput() { this.value = this.value.replace(/\D/g, ''); validate(); }
  function onSDIInput()  { this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g, ''); validate(); }

  /* ── Init ────────────────────────────────────────────────────── */
  function init() {
    setCheckout(false);

    var tipoAcquisto = document.getElementById('fiscal-tipo-acquisto');
    if (!tipoAcquisto) return; // snippet non presente in questa pagina

    tipoAcquisto.addEventListener('change', onTipoAcquistoChange);

    document.querySelectorAll('.fiscal-radio').forEach(function (radio) {
      radio.addEventListener('change', onTipoSoggettoChange);
    });

    var cfInput   = document.getElementById('fiscal-cf');
    var pivaInput = document.getElementById('fiscal-piva');
    var sdiInput  = document.getElementById('fiscal-sdi');

    if (cfInput)   cfInput.addEventListener('input', onCFInput);
    if (pivaInput) pivaInput.addEventListener('input', onPIVAInput);
    if (sdiInput)  sdiInput.addEventListener('input', onSDIInput);

    // Intercetta tutti i click (capture phase) per gestire il pulsante checkout
    document.addEventListener('click', onCheckoutClick, true);

    // Blocca anche submit diretto del form carrello
    document.addEventListener('submit', function (e) {
      var btn = e.target.querySelector(CHECKOUT_BTN_SELECTORS);
      if (btn && btn.classList.contains(DISABLED_CLASS)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showValidationMsg();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
